import { createStyles } from "@mantine/emotion";

export const useStylesTooltip = createStyles((theme) => ({
  tooltip: {
    color: theme.customColors.black,
    backgroundColor: theme.customBackgrounds.white,
    pointerEvents: "auto",
    border: "1px solid " + theme.customColors.greenTooltip,
    maxWidth: "100%",
    boxShadow: "2px 4px 6px " + theme.customColors.blackLight,
    "&:hover button": {
      backgroundColor: theme.customColors.greenTooltip,
    },
  },

  tooltipArrow: {
    borderLeft: `${theme.spacing.tooltip.border.width} solid ${theme.customColors.greenTooltip}`,
    borderTop: `${theme.spacing.tooltip.border.width} solid ${theme.customColors.greenTooltip}`,
    borderLeftColor: theme.customColors.greenTooltip,
    borderTopColor: theme.customColors.greenTooltip,
  },
  tooltipText: {
    whiteSpace: "pre-line",
    textAlign: "justify",
    paddingBottom: theme.spacing.tooltip.padding.bottom,
    ".b": {
      fontWeight: "bold",
    },
  },
  tooltipButton: {
    border: `1px solid ${theme.customColors.blackLight}`,
    width: theme.spacing.tooltip.size.button.width,
    height: theme.spacing.tooltip.size.button.height,
    padding: "0",
    minWidth: theme.spacing.tooltip.size.button.minWidth,
    minHeight: theme.spacing.tooltip.size.button.minHeight,
    backgroundColor: theme.customColors.white,
    "&:hover": {
      backgroundColor: theme.customColors.greenTooltip,
    },
    svg: {
      width: `${theme.spacing.tooltip.size.icon.width} !important`,
      height: `${theme.spacing.tooltip.size.icon.height} !important`,
    },
  },
}));
